<template>
  <div class="state-wrap">
    <div class="left">
      <IconTitle
        :label="item.classifyLabel"
        :result="item.result"
        :type="type"
        :describe="describe"
        :remark="remark"
      ></IconTitle>
      <div class="title">状态分析</div>
      <ColorBar :type="type" :legend="legend" :percent="percent"></ColorBar>
    </div>
    <div class="right">
      <div class="title">建议:</div>
      <div v-html="item.appraise" :class="[printing ? 'appraise' : '']"></div>
    </div>
    <DashedLine></DashedLine>
    <div :class="[item.splitpage ? 'page' : '']"></div>
  </div>
</template>

<script>
import DashedLine from "../dashedline.vue";
export default {
  components: {
    DashedLine,
  },
  props: {
    item: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    type() {
      let n = Number(this.item.gradeValue);
      if (n > 5) {
        return "xiao";
      } else {
        return "ku";
      }
    },
    gradeListPart() {
      if (this.type == "xiao") {
        return this.item.gradeList.slice(-5);
      } else {
        return this.item.gradeList.slice(0, 5).reverse();
      }
    },
    legend() {
      return this.gradeListPart.map((m) => m.dictLabel);
    },
    percent() {
      let index = this.gradeListPart.findIndex(
        (e) => e.dictValue == this.item.gradeValue
      );
      return index * 20 + 10;
    },
    describe() {
      return this.item.describe;
    },
    remark() {
      let item = this.item.gradeList.find(
        (f) => f.dictValue == this.item.gradeValue
      );
      if (item) {
        return item.remark;
      } else {
        return "";
      }
    },
    printing() {
      return this.$store.state.Printing;
    },
  },
};
</script>

<style scoped lang="scss">
.state-wrap {
  background: rgb(246, 255, 250);
  .left {
    padding: 20px;
  }
  .right {
    padding: 20px;
    font-size: 14px;
    .title {
      color: red;
      font-weight: 600;
      margin-bottom: 5px;
    }
    .appraise {
      height: 260px;
    }
  }
}
</style>